module.exports = __webpack_public_path__ + "img/youtube-icon.11b095f0.svg";